import { render, staticRenderFns } from "./ClientPageHeader.vue?vue&type=template&id=4bb6606c&scoped=true&"
import script from "./ClientPageHeader.vue?vue&type=script&lang=ts&"
export * from "./ClientPageHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ClientPageHeader.vue?vue&type=style&index=0&id=4bb6606c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb6606c",
  null
  
)

export default component.exports